import { Card, CardContent, Typography } from "@mui/material";
import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

interface AppointmentsChartProps {
  data?: Array<{
    name: string;
    value: number;
    color: string;
  }>;
  className?: string;
}

const AppointmentsChart: React.FC<AppointmentsChartProps> = ({
  data = [
    { name: "Consultation", value: 35, color: "#8884d8" },
    { name: "Other", value: 25, color: "#82ca9d" },
    { name: "Emergency", value: 22, color: "#ffc658" },
    { name: "Check-up", value: 18, color: "#ff7300" },
  ],
  className = "",
}) => {
  return (
    <Card
      className={className}
      sx={{
        boxShadow: "none",
        border: "1px solid #d1d5db", // border-gray-300 equivalent
      }}
    >
      <CardContent>
        <Typography
          variant="h6"
          className="text-lg font-medium text-gray-600 mb-4"
        >
          Appointments
        </Typography>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={false}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {data.map((entry) => (
                <Cell key={`cell-${entry.name}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default AppointmentsChart;
